module.exports = __webpack_public_path__ + "static/media/25487452_1703514829723701_2221406157324187239_o.9f39fcc1.jpg";